import {
  DutyScheduleTableColumns,
  DutyScheduleTableLayout,
} from "@/pages/duty-schedule/pages/duty-schedule-detail/components/table-layout/DutyScheduleTableLayout";
import {
  DutyScheduleDistributionRow,
  TOTALS_KEY,
} from "@/pages/duty-schedule/pages/duty-schedule-detail/pages/distribution/DutyScheduleDistribution.utils";
import { useTranslation } from "@/translations";

import { buildCounselorColumn, buildNumericColumns } from "./DutyScheduleDistributionTable.utils";

interface Props {
  rows: DutyScheduleDistributionRow[];
  totalsRow: DutyScheduleDistributionRow;
}

export function DutyScheduleDistributionTable({ rows, totalsRow }: Props) {
  const { t, i18n } = useTranslation();

  const columns: DutyScheduleTableColumns<DutyScheduleDistributionRow> = [
    buildCounselorColumn(t),
    ...buildNumericColumns(t, i18n.language),
  ];

  return (
    <DutyScheduleTableLayout
      ariaLabel={t("dutySchedule.detail.distribution.table.tableAria")}
      columns={columns}
      data={[...rows, totalsRow]}
      getRowId={(row) => row.key}
      isRowHoverable={(row) => row.key !== TOTALS_KEY}
    />
  );
}
